import {
  IAdminUser,
  IAdminUserInvitation,
  IAdminUsersPerOrg
} from '@dadohr/shared/domainTypes/adminUser';
import { generateToDocFn } from '@dadohr/shared/domainTypes/document';
import {
  FULL_SCOPES_ACCOUNT_ADMIN,
  USER_ROLE
} from '@dadohr/shared/domainTypes/permissions';
import { difference } from 'lodash';

const INITIAL_ADMIN_SCOPES = [
  'experience.template.create',
  'experience.template.edit',
  'experience.template.view',
  'experience.template.launch',
  'org.adminUsers.view',
  'org.integrations.view',
  'org.mappings.view',
  'org.settings.view',
  'user.imports.view'
];

export const toAdminUserDoc = generateToDocFn<IAdminUser>((d) => {
  d.firstName = d.firstName || '';
  d.middleName = d.middleName || '';
  d.preferredName = d.preferredName || '';
  d.lastName = d.lastName || '';
  d.avatar = d.avatar || '';
  return d;
});

export const toAdminUserInvitationDoc = generateToDocFn<IAdminUserInvitation>(
  (d) => {
    d.status = d.status || 'PENDING';
    d.scopes = d.scopes || FULL_SCOPES_ACCOUNT_ADMIN().v2.scopes;
    d.role =
      d.role ||
      (difference(INITIAL_ADMIN_SCOPES, d.scopes).length === 0
        ? USER_ROLE.ACCOUNT_ADMIN
        : USER_ROLE.EXPERIENCE_MANAGER);
    d.additionalExperienceTemplateScopes =
      d.additionalExperienceTemplateScopes || {};
    return d;
  }
);

export const toAdminUsersPerOrgDoc = generateToDocFn<IAdminUsersPerOrg>();
